import {SocialShare} from "../class-lib/social-share";
import {createListItem} from '../class-lib/global-functions';

declare global {
    interface Window {
        renderRelated: any;
        test: any;
        modal: any;
    }
}

declare var ajaxDataMain: {
    home_url: string;
};

var pdfjsLib = require("pdfjs-dist");

var pdfPath = "http://akademie.sbw.local/wp-content/uploads/2020/06/PDF-test.pdf";

// Setting worker path to worker bundle.
pdfjsLib.GlobalWorkerOptions.workerSrc = window.location.origin + "/wp-content/themes/elumine-child/assets/js/vendor/pdf.worker.bundle.js";

document.addEventListener('DOMContentLoaded', function () {
    // new EventSingle();
    new SocialShare();

    jQuery('.download-item').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let form = document.getElementById('download-form') as HTMLFormElement;
        jQuery(form).find('input[name="hash"]').val(jQuery(this).data('hash'));
        jQuery(form).find('input[name="type"]').val(jQuery(this).data('type'));
        jQuery(form).find('input[name="files"]').val('');
        form.setAttribute("action", ajaxDataMain.home_url + "/dokument-herunterladen");
        window.open('', 'view');
        form.submit();
    })

    jQuery('.download-all').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let form = document.getElementById('download-form') as HTMLFormElement;
        jQuery(form).find('input[name="files"]').val(jQuery(this).data('meta'));
        form.setAttribute("action", ajaxDataMain.home_url + "/dokument-herunterladen");
        window.open('', 'view');
        form.submit();
    })

    document.querySelector('.validate-bundle')?.addEventListener('click', () => {
        validateBundleForm();
    });

    window.renderRelated = function (containerId: string, data: object[]) {
        console.log('renderRelated')
        let container = document.getElementById(containerId);
        if (data.length && container) {
            for (let i = 0; i < data.length; i++) {
                let d = data[i];
                let el = createListItem(d, 'col-lg-12');
                if (container && el) {
                    container.append(el);
                }
            }
        }
    }

    function validateBundleForm() {
        let form = document.querySelector('form#bundle');
        let selectorNodes = form?.querySelectorAll('select.sta_event_ticket');
        if (selectorNodes?.length) {
            Array.from(selectorNodes).forEach((selector: HTMLSelectElement) => {
                if (selector.value === '') {
                    selector.parentElement.classList.add('invalid');
                }
            })
        }
    }

    window.test = function () {
        const loadingTask = pdfjsLib.getDocument(pdfPath);
        // loadingTask.
        loadingTask.promise
            .then(function (pdfDocument: { getPage: (arg0: number) => Promise<any>; }) {
                // Request a first page
                return pdfDocument.getPage(1).then(function (pdfPage) {
                    const viewport = pdfPage.getViewport({scale: 1.0});
                    const canvas = document.createElement("canvas");
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    const ctx = canvas.getContext("2d");
                    const renderTask = pdfPage.render({
                        canvasContext: ctx,
                        viewport: viewport,
                    });
                    window.modal.open('PDF', '', canvas, {width: '100%'})
                    return renderTask.promise;
                });
            })
            // @ts-ignore
            .catch(function (reason) {
                console.error("Error: " + reason);
            });
    }
});
